import { useEffect, useState } from "react";
import {
  SolutionPointButton,
  SolutionPointButtonWrapper,
  SolutionPointDataItem,
  SolutionPointDataWrapper,
  SolutionPointHeader,
  SolutionPointHeaderItem,
  SolutionPointWrapper,
} from "./style";
import {
  SettlementResponse,
  SettlementTournament,
} from "../../../../api/settlement";
import { useRecoilValue } from "recoil";
import { WideState } from "../../../../recoil/wide";

interface SolutionPointProps {
  data: SettlementResponse | undefined;
  handleManualPoint?: () => void;
  type: "POINT" | "SEED" | "MILEAGE" | "CARROT";
  handleHistoryOpen: (value: string) => void;
  date: string;
  allList?: SettlementTournament[];
  handleDepositPopup?: () => void;
  handleMileageFun?: {
    handleManualPopup: () => void;
    handleOrderManagement: () => void;
    handleOrderMenuManagement: () => void;
  };
  title: string;
}
export const SolutionPoint = ({
  data,
  handleManualPoint,
  handleHistoryOpen,
  type,
  date,
  allList,
  handleDepositPopup,
  title,
  handleMileageFun,
}: SolutionPointProps) => {
  const [seed, setSeed] = useState(0);
  const [carrot, setCarrot] = useState(0);
  const [usedPoint, setUsedPoint] = useState(0);
  const [transactionPoint, setTransactionPoint] = useState(0);
  const [userTotalPoint, setUserTotalPoint] = useState(0);
  const [pubTotalPoint, setPubTotalPoint] = useState(0);
  const [tournamentSeed, setTournamentSeed] = useState(0);
  const [entrySeed, setEntrySeed] = useState(0);
  const [carrotOut, setCarrotOut] = useState(0);
  const [pointPrize, setPointPrize] = useState(0);
  const isWide = useRecoilValue(WideState);

  useEffect(() => {
    if (!data || !allList || !setSeed) return;

    setSeed(data.pubSeed);
    setTournamentSeed(data.seedOut);
    setEntrySeed(data.seedIn);
  }, [data, allList]);

  useEffect(() => {
    if (!data) return;
    const usePoint = data.tournaments.reduce((a, b) => a + b.usedPoint, 0);
    setUsedPoint(usePoint);
    setTransactionPoint(data.transactionPoint);
    setUserTotalPoint(data.totalMemberPoint);
    setPubTotalPoint(data.pubPoint);
    setPointPrize(data.pointPrize);
    setCarrot(data.pubCarrot ?? 0);
    setCarrotOut(data.carrotOut ?? 0);
  }, [data]);

  const PointHeader = [
    {
      name: `전체 매장 보유`,
      value: pubTotalPoint / 10000,
      unit: "E",
      color: "red",
    },
    {
      name: `전체 유저 보유`,
      value: userTotalPoint / 10000,
      unit: "E",
      color: "purple",
    },
  ];

  const SeedHeader = [
    {
      name: `보유`,
      value: +seed,
      unit: "RABBIT",
      color: "",
    },
  ];

  const CarrotHeader = [
    {
      name: `보유`,
      value: +carrot,
      unit: "CARROT",
      color: "",
    },
  ];

  const MileageHeader = [
    {
      name: `회원 보유`,
      value: data?.memberMileage,
      unit: "M",
      color: "",
    },
  ];

  const PointPayType = [
    {
      name: `매장 → 회원`,
      value: transactionPoint / 10000 + pointPrize / 10000,
      unit: "E",
    },
    {
      name: "회원 사용 (소멸)",
      value: usedPoint / 10000,
      unit: "E",
    },
  ];

  const SeedPayType = [
    {
      name: `회원 → 매장(사용)`,
      value: entrySeed,
      unit: "RABBIT",
    },
    {
      name: "매장 → 회원(시상)",
      value: tournamentSeed,
      unit: "RABBIT",
    },
  ];

  const CarrotPayType = [
    {
      name: "매장 → 회원(시상)",
      value: carrotOut,
      unit: "CARROT",
    },
  ];

  const MileagePayType = [
    {
      name: `회원 → 매장(사용)`,
      value: data?.mileageUsed,
      unit: "M",
    },
    {
      name: "매장 → 회원(지급)",
      value: data?.mileageOut,
      unit: "M",
    },
  ];

  const getHeader = () => {
    if (type === "POINT") return PointHeader;
    if (type === "SEED") return SeedHeader;
    if (type === "CARROT") return CarrotHeader;
    return MileageHeader;
  };

  const getPayType = () => {
    if (type === "POINT") return PointPayType;
    if (type === "SEED") return SeedPayType;
    if (type === "CARROT") return CarrotPayType;
    return MileagePayType;
  };

  const getBoxClass = () => {
    if (type === "POINT") return "box1";
    if (type === "SEED") return "box2";
    if (type === "CARROT") return "box3";
    return "box4";
  };

  const formatDate = (value: string) => {
    return `${value.split("-")[2]}일`;
  };

  const handleHistory = () => {
    handleHistoryOpen(type);
  };

  return (
    <SolutionPointWrapper isWide={isWide} className={getBoxClass()}>
      <div className="header">{title}</div>
      <SolutionPointHeader type={type}>
        {getHeader().map((item, index) => (
          <SolutionPointHeaderItem type={type} key={index}>
            <div className="name">{item.name}</div>
            <div className={`value ${item?.color || ""}`}>
              <div>
                {item.value?.toLocaleString()} {item.unit}
              </div>
            </div>
          </SolutionPointHeaderItem>
        ))}
      </SolutionPointHeader>
      <SolutionPointDataWrapper>
        <div className="date">{formatDate(date)}</div>
        {getPayType().map((item, index) => (
          <SolutionPointDataItem key={index}>
            <div className="name">{item.name}</div>
            <div className="value">
              {item.value?.toLocaleString()} <span>{item.unit}</span>
            </div>
          </SolutionPointDataItem>
        ))}
      </SolutionPointDataWrapper>
      {type === "POINT" ? (
        <SolutionPointButtonWrapper>
          <SolutionPointButton onClick={() => handleManualPoint?.()}>
            E 수동 지급 & 차감
          </SolutionPointButton>
          <SolutionPointButton type="gray" onClick={handleHistory}>
            매장 이용권 내역
          </SolutionPointButton>
          <SolutionPointButton onClick={() => handleDepositPopup?.()}>
            주류마일리지 구매
          </SolutionPointButton>
        </SolutionPointButtonWrapper>
      ) : type === "SEED" ? (
        <SolutionPointButtonWrapper>
          <SolutionPointButton
            style={{ gridColumn: "span 2" }}
            onClick={handleHistory}
          >
            크레딧 내역
          </SolutionPointButton>
          <SolutionPointButton
            type="gray"
            onClick={() => handleHistoryOpen("LEGACY_SEED")}
          >
            (구)크레딧 내역
          </SolutionPointButton>
        </SolutionPointButtonWrapper>
      ) : type === "CARROT" ? (
        <SolutionPointButtonWrapper>
          <SolutionPointButton
            style={{ gridColumn: "span 2" }}
            onClick={handleHistory}
          >
            캐럿 내역
          </SolutionPointButton>
        </SolutionPointButtonWrapper>
      ) : (
        <SolutionPointButtonWrapper>
          <SolutionPointButton
            onClick={() => handleMileageFun?.handleOrderMenuManagement()}
          >
            메뉴 관리
          </SolutionPointButton>
          <SolutionPointButton
            onClick={() => handleMileageFun?.handleOrderManagement()}
          >
            실시간 알림
          </SolutionPointButton>
          <SolutionPointButton
            onClick={() => handleMileageFun?.handleManualPopup()}
          >
            주류마일리지 상품 구매 & 수동 지급
          </SolutionPointButton>
          <SolutionPointButton type="gray" onClick={handleHistory}>
            주류마일리지 내역
          </SolutionPointButton>
        </SolutionPointButtonWrapper>
      )}
    </SolutionPointWrapper>
  );
};
